import React from 'react';
import { Link } from 'react-router-dom';
import { apTheme, type AgentPlatformArea, agentPlatformAreaLabels } from '../../utils/agentPlatformTheme';

type Props = {
  backTo?: string;
  backLabel?: string;
  title: string;
  subtitle?: string;
  area?: AgentPlatformArea | null;
  tone?: 'light' | 'dark';
  actions?: React.ReactNode;
  meta?: React.ReactNode;
  className?: string;
};

export const AgentPlatformPageHeader: React.FC<Props> = ({
  backTo = '/agent-platform',
  backLabel = 'Plataforma Agêntica',
  title,
  subtitle,
  area = null,
  tone = 'light',
  actions,
  meta,
  className = '',
}) => {
  const isDark = tone === 'dark';

  return (
    <header className={`${isDark ? 'mb-0' : 'mb-8'} ${className}`}>
      <Link
        to={backTo}
        className={`inline-flex items-center gap-1 text-sm font-medium transition-colors ${
          isDark ? 'text-red-300 hover:text-white' : apTheme.link
        }`}
      >
        <span aria-hidden>←</span> {backLabel}
      </Link>
      <div className="mt-3 flex flex-wrap items-start justify-between gap-4">
        <div className="space-y-2">
          <div className="flex flex-wrap items-center gap-3">
            <h1
              className={`text-2xl sm:text-3xl font-bold tracking-tight ${
                isDark ? 'text-white' : 'text-stone-900'
              }`}
            >
              {title}
            </h1>
            {area && (
              <span
                className={`text-xs font-semibold uppercase tracking-wider px-2.5 py-1 rounded-full ${
                  isDark ? 'bg-white/10 text-red-200 ring-1 ring-white/20' : apTheme.badge[area]
                }`}
              >
                {agentPlatformAreaLabels[area]}
              </span>
            )}
          </div>
          {subtitle && (
            <p
              className={`text-sm max-w-2xl leading-relaxed ${
                isDark ? 'text-stone-400' : 'text-stone-600'
              }`}
            >
              {subtitle}
            </p>
          )}
          {meta}
        </div>
        {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
      </div>
    </header>
  );
};
